HProgressBarComponent.$inject = [];

function HProgressBarComponent() {
    var self = this;
    self.trackerWidth = 0;

    self.$onChanges = function () {
        self.trackerWidth = ((self.weight / self.totalWeight) * 100);
        self.trackerWidth = self.trackerWidth > 100 ? 100 : parseInt(self.trackerWidth);
    };
}

angular
    .module("harriApp")
    .component("hProgressBar", {
        controller: HProgressBarComponent,
        bindings: {
            weight: '<',
            totalWeight: '<',
            cssClass: '@',
        },
        controllerAs: '$ctrl',
        templateUrl: '../hmodules/components/h-progress-bar/h-progress-bar.component.ng.html'
    });
